// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__124w9","top":"styles_top__3Hytb","left":"styles_left__edyty","description":"styles_description__26c9N"};